module.exports = __webpack_public_path__ + "img/1606.68bb1e92.png";